import Vue from "vue";
const eventHub = new Vue();
Vue.mixin({
  data: function() {
    return {
      eventHub: eventHub
    };
  }
});
